const translation = {
  pageTitle: 'अरे, चलिए शुरू करते हैं!👋',
  welcome: 'Dify में आपका स्वागत है, कृपया जारी रखने के लिए लॉग इन करें।',
  email: 'ईमेल पता',
  emailPlaceholder: 'आपका ईमेल',
  password: 'पासवर्ड',
  passwordPlaceholder: 'आपका पासवर्ड',
  name: 'उपयोगकर्ता नाम',
  namePlaceholder: 'आपका उपयोगकर्ता नाम',
  forget: 'क्या आप पासवर्ड भूल गए?',
  signBtn: 'साइन इन करें',
  sso: 'SSO के साथ जारी रखें',
  installBtn: 'सेट अप करें',
  setAdminAccount: 'एडमिन खाता सेट कर रहे हैं',
  setAdminAccountDesc:
    'एडमिन खाते के लिए अधिकतम विशेषाधिकार, जिसका उपयोग एप्लिकेशन बनाने और LLM प्रदाताओं को प्रबंधित करने के लिए किया जा सकता है, आदि।',
  createAndSignIn: 'बनाएं और साइन इन करें',
  oneMoreStep: 'एक और कदम',
  createSample: 'इस जानकारी के आधार पर, हम आपके लिए नमूना एप्लिकेशन बनाएंगे',
  invitationCode: 'निमंत्रण कोड',
  invitationCodePlaceholder: 'आपका निमंत्रण कोड',
  interfaceLanguage: 'इंटरफेस भाषा',
  timezone: 'समय क्षेत्र',
  go: 'Dify पर जाएं',
  sendUsMail:
    'हमें अपना परिचय ईमेल करें, और हम निमंत्रण अनुरोध को संभाल लेंगे।',
  acceptPP: 'मैंने गोपनीयता नीति पढ़ी है और स्वीकार करता हूं',
  reset: 'कृपया अपना पासवर्ड रीसेट करने के लिए निम्नलिखित कमांड चलाएं',
  withGitHub: 'GitHub के साथ जारी रखें',
  withGoogle: 'Google के साथ जारी रखें',
  rightTitle: 'LLM की पूरी क्षमता को अनलॉक करें',
  rightDesc:
    'दृश्य रूप से आकर्षक, संचालन योग्य और सुधार योग्य AI एप्लिकेशन को आसानी से बनाएं।',
  tos: 'सेवा की शर्तें',
  pp: 'गोपनीयता नीति',
  tosDesc: 'साइन अप करके, आप हमारी सहमति देते हैं',
  goToInit:
    'यदि आपने खाता प्रारंभ नहीं किया है, तो कृपया प्रारंभिक पृष्ठ पर जाएं',
  dontHave: 'नहीं है?',
  invalidInvitationCode: 'अवैध निमंत्रण कोड',
  accountAlreadyInited: 'खाता पहले से प्रारंभ किया गया है',
  forgotPassword: 'क्या आपने अपना पासवर्ड भूल गए हैं?',
  resetLinkSent: 'रीसेट लिंक भेजी गई',
  sendResetLink: 'रीसेट लिंक भेजें',
  backToSignIn: 'साइन इन पर वापस जाएं',
  forgotPasswordDesc: 'कृपया अपना ईमेल पता दर्ज करें ताकि हम आपको अपना पासवर्ड रीसेट करने के निर्देशों के साथ एक ईमेल भेज सकें।',
  checkEmailForResetLink: 'कृपया अपना पासवर्ड रीसेट करने के लिए लिंक के लिए अपना ईमेल चेक करें। अगर यह कुछ मिनटों के भीतर नहीं आता है, तो कृपया अपना स्पैम फोल्डर भी चेक करें।',
  passwordChanged: 'अब साइन इन करें',
  changePassword: 'पासवर्ड बदलें',
  changePasswordTip: 'कृपया अपने खाते के लिए नया पासवर्ड दर्ज करें',
  invalidToken: 'अमान्य या समाप्त टोकन',
  confirmPassword: 'पासवर्ड की पुष्टि करें',
  confirmPasswordPlaceholder: 'अपना नया पासवर्ड पुष्टि करें',
  passwordChangedTip: 'आपका पासवर्ड सफलतापूर्वक बदल दिया गया है',
  error: {
    emailEmpty: 'ईमेल पता आवश्यक है',
    emailInValid: 'कृपया एक मान्य ईमेल पता दर्ज करें',
    nameEmpty: 'नाम आवश्यक है',
    passwordEmpty: 'पासवर्ड आवश्यक है',
    passwordLengthInValid: 'पासवर्ड कम से कम 8 वर्णों का होना चाहिए',
    passwordInvalid:
      'पासवर्ड में अक्षर और अंक होने चाहिए, और लंबाई 8 से अधिक होनी चाहिए',
    registrationNotAllowed: 'खाता नहीं मिला. रजिस्टर करने के लिए कृपया सिस्टम एडमिन से संपर्क करें।',
  },
  license: {
    tip: 'Dify Community Edition शुरू करने से पहले, GitHub पर',
    link: 'ओपन-सोर्स लाइसेंस',
  },
  join: 'शामिल हों',
  joinTipStart: 'आपको आमंत्रित करते हैं',
  joinTipEnd: 'टीम पर Dify',
  invalid: 'लिंक समाप्त हो गया है',
  explore: 'Dify का अन्वेषण करें',
  activatedTipStart: 'आप शामिल हो गए हैं',
  activatedTipEnd: 'टीम',
  activated: 'अब साइन इन करें',
  adminInitPassword: 'एडमिन प्रारंभिक पासवर्ड',
  validate: 'सत्यापित करें',
  checkCode: {
    verify: 'जाँचना',
    verificationCode: 'सत्यापन कोड',
    invalidCode: 'अमान्य कोड',
    useAnotherMethod: 'किसी अन्य विधि का उपयोग करें',
    emptyCode: 'कोड आवश्यक है',
    didNotReceiveCode: 'कोड प्राप्त नहीं हुआ?',
    resend: 'भेजें',
    checkYourEmail: 'अपना ईमेल जांचें',
    validTime: 'ध्यान रखें कि कोड 5 मिनट के लिए वैध है',
    tips: 'हम <strong>{{email}}</strong> को एक सत्यापन कोड भेजते हैं',
    verificationCodePlaceholder: '6-अंक कोड दर्ज करें',
  },
  sendVerificationCode: 'पुष्टि कोड भेजें',
  or: 'नहीं तो',
  continueWithCode: 'कोड के साथ जारी रखें',
  resetPassword: 'पासवर्ड रीसेट करें',
  changePasswordBtn: 'पासवर्ड सेट करें',
  setYourAccount: 'अपना खाता सेट करें',
  useVerificationCode: 'सत्यापन कोड का उपयोग करें',
  usePassword: 'पासवर्ड का उपयोग करें',
  backToLogin: 'लॉगिन पर वापस जाएं',
  noLoginMethod: 'प्रमाणीकरण विधि कॉन्फ़िगर नहीं की गई',
  enterYourName: 'कृपया अपना उपयोगकर्ता नाम दर्ज करें',
  noLoginMethodTip: 'प्रमाणीकरण विधि जोड़ने के लिए कृपया सिस्टम व्यवस्थापक से संपर्क करें.',
  resetPasswordDesc: 'वह ईमेल टाइप करें जिसका उपयोग आपने Dify पर साइन अप करने के लिए किया था और हम आपको एक पासवर्ड रीसेट ईमेल भेजेंगे।',
  withSSO: 'एसएसओ के साथ जारी रखें',
  back: 'पीछे',
  licenseInactive: 'लाइसेंस निष्क्रिय',
  licenseExpired: 'लाइसेंस की समय सीमा समाप्त हो गई',
  licenseLost: 'लाइसेंस खो गया',
  licenseLostTip: 'Dify लायसेंस सर्वर से कनेक्ट करने में विफल. Dify का उपयोग जारी रखने के लिए कृपया अपने व्यवस्थापक से संपर्क करें.',
  licenseInactiveTip: 'आपके कार्यस्थल के लिए डिफाई एंटरप्राइज लाइसेंस निष्क्रिय है। कृपया डिफाई का उपयोग जारी रखने के लिए अपने प्रशासक से संपर्क करें।',
  licenseExpiredTip: 'आपके कार्यस्थल के लिए डिफाई एंटरप्राइज लाइसेंस समाप्त हो गया है। कृपया डिफाई का उपयोग जारी रखने के लिए अपने प्रशासक से संपर्क करें।',
  webapp: {
    noLoginMethodTip: 'कृपया एक प्रमाणीकरण विधि जोड़ने के लिए सिस्टम प्रशासक से संपर्क करें।',
    noLoginMethod: 'वेब ऐप के लिए प्रमाणीकरण विधि कॉन्फ़िगर नहीं की गई है',
    disabled: 'वेब ऐप प्रमाणीकरण अक्षम है। कृपया इसे सक्षम करने के लिए सिस्टम प्रशासक से संपर्क करें। आप सीधे ऐप का उपयोग करने की कोशिश कर सकते हैं।',
  },
}

export default translation
